export default __webpack_public_path__ + "static/media/FrankHomies-524.ca84ab61.png";